const { upgradeArray } = require('../utils')

const STORAGE_EXPIRES = upgradeArray([ 'expire-none', 'expire-2', 'expire-30', 'expire-60' ])

module.exports = {
  STORAGE_EXPIRES
}
